import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { DialogTitleProps } from "./BootStrapDialog";

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0 }} {...other}>
            <div className={'flex justify-between items-center'}>
                <div className={'flex-grow-1 text-capitalize'}>{children}</div>
                <div>
                    {onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                color: (theme) => theme.palette.grey[500],
                            }}>
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </div>
            </div>
        </DialogTitle>
    );
};


export default BootstrapDialogTitle;